const isCostTop = () => {
  return false;
};

const isGuard = () => {
  return false;
};

// 获取用户发言时所要用到的颜色值
const getNickNameColor = function (user) {
  var color = '';

  if (isCostTop(user)) {
    color = 'mt-nickname-richest';
  } else if (isGuard(user)) {
    color = 'mt-nickname-guard';
  } else if (user.vip) {
    color = 'mt-nickname-svip';
  }
  // 炫彩昵称, 后面以 colourful_name 为准，星钻相关废弃
  if (user.colourful_name) {
    color = 'mt-nickname-star-vip';
  }

  return color;
};

let formatUserData = (user) => {
  return user;
};

export default {
  getNickNameColor,
  formatUserData,
};
